import { colors } from '../../colors';
var address = {
  arrowColor: colors.dustyTeal,
  textColor: colors.charcoalGrey,
  borderColor: colors.charcoalGrey,
  backgroundColor: colors.offWhite
};
export default address;